import { DatePicker, Form } from "antd";
import React, { useState } from "react";
import dayjs from 'dayjs';
import { b2c2bDateFormat, departureDateFormat, categoryDobDisabledDate } from "../../../utils/antd.props";

// Can not select dates after today
const futureDates = (current) => {
  return current && current > dayjs().endOf('day');
};

const nonInfantDates = (current, departureDate) => {
  return current > dayjs().endOf("day") || current < dayjs().subtract(2, "year").startOf("day") || (departureDate && current > dayjs(departureDate, departureDateFormat).toDate())
};

export default function AgeValidatorField(props) {
  const { agegroup, departuredate, category, childAgeRanges, disabled, onChange, ...formItemProps } = props;
  const [mode, setMode] = useState("year");

  const validationByType = (current) => {
    switch (agegroup) {
      case "infant":
        return nonInfantDates(current, departuredate);

      default:
        if (category && childAgeRanges) {
          return categoryDobDisabledDate(current, category, departuredate, childAgeRanges);
        }
        return futureDates(current);
    }
  }

  return (
    <Form.Item {...formItemProps}>
      <DatePicker
        format={b2c2bDateFormat}
        disabledDate={(current)=>validationByType(current)}
        disabled={disabled}
        mode={mode}
        onOpenChange={(open) => { if (open) setMode("year"); }}
        onPanelChange={(_, newMode) => setMode(newMode)}
        onChange={(...args) => { setMode("year"); onChange?.(...args); }}
      />
    </Form.Item>
  )
}

AgeValidatorField.defaultProps = {
  label: "Date of Birth",
  name: "date_of_birth",
  agegroup: "adult"
}